import { Component, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { OpenDialogYesOrNo } from '../dialog-yes-or-no/dialog-yes-or-no.component';
import { ApplicantService } from '../applicant.service';
import { CibilReportService } from '../financial/cibil-report/cibil-report.service';
import * as constants from '../../constant'

@Component({
  selector: 'wl-land-records-mp',
  templateUrl: './land-records-mp.component.html',
  styles: []
})
export class LandRecordsMpComponent implements OnInit {
  landForm: UntypedFormGroup;
  districts: any = [];
  tehsils: any = [];
  villages: any = [];
  districtDisabled: boolean;
  tehsilDisabled: boolean;
  villageDisabled: boolean;
  khasraDisabled: boolean;
  showWaitingLR: boolean;
  subText: string;
  showSpinnerWithMessage: boolean;
  isNTB: boolean;
  profile: any;
  ownershipForm: UntypedFormGroup;
  mappingData: any;
  noOfDocuments: any;
  readOnlyArray: any;
  isFetchButtonDisabled: boolean;
  breArray: any[];
  disableSubmitLandRecords: boolean = false;
  breArrayNew: void[];
  rabiCropList: any;
  kharifCropList: any;
  rabiCropListNew: any[];
  rabiCropListNew2: any[];
  kharifCropListNew: any[];
  kharifCropListNew2: any[];
  namesArray: any[];
  acreOrHectare: string;
  feedbackflag: boolean;
  isLandBreFailure: boolean = false;
  stateCode: string;
  state: any;
  halka: any;
  halkaDisabled: boolean;
  repeatGetCreditScoreAPICount = 1;
  pointerStyle: object;
  matchedArrays: any[];
  isMatch: boolean;
  hideSubmitButton: boolean = false;
  showDelete: boolean;
  creditCheckRequired: any;
  disableBcoz5landsAlready: boolean;

  constructor(private fb: UntypedFormBuilder, private applicant: ApplicantService, private dialog: MatDialog, private router: Router, private snackbar: MatSnackBar, private creditreport: CibilReportService) {
    this.landForm = this.fb.group({

      district: ['', Validators.required],
      tehsil: ['', Validators.required],
      halka: ["", Validators.required],
      village: ['', Validators.required],
      khasra: ['', Validators.required],

    })

    this.ownershipForm = this.fb.group({
      bhoomi_details: this.fb.array([])
    })

    if (this.applicant.shouldIbeClicked()) {
      this.pointerStyle = { 'pointer-events': 'auto' }
    } else {
      this.pointerStyle = { 'pointer-events': 'none' }
    }

  }
  bhoomi_details(): UntypedFormArray {
    return this.ownershipForm.get("bhoomi_details") as UntypedFormArray
  }

  newBhoomiDetail(): UntypedFormGroup {
    return this.fb.group({
      name_as_per_bhumi: '',
      land_area: '',
      land_ownership: '',
      charge_details: '',
      // land_value: ''
    })
  }

  addBhoomiDetail() {
    this.bhoomi_details().push(this.newBhoomiDetail());

  }

  ngOnInit() {

    let stateValue = sessionStorage.getItem('wEnlw3OeU3')

    if (stateValue == "xmpHUKBVNVSFG61XnJAzKOQ32EWjSdE1") {
      this.acreOrHectare = "Hectare"
      this.stateCode = "MP"
    } else if (stateValue == "KDw2nS6vb5cJ286KJ3JwtGKGnnnLO93Y") {
      this.acreOrHectare = "Acre"
      this.stateCode = "KA"
    } else if (stateValue == "X0ZUk5Z7otQSnJFm9rc2bcAvwPrp66i6") {
      this.acreOrHectare = "Acre"
      this.stateCode = "AP"
    }

    this.tehsilDisabled = true
    this.villageDisabled = true
    this.khasraDisabled = true
    this.halkaDisabled = true;



    this.applicant.getProfile().subscribe(profile => {
      this.profile = profile;
      console.log("Profile ", profile);
      this.applicant.getLandDetails().subscribe(resp => {
        console.log(resp, "124")
        // if(resp && resp.success){
        if (resp && resp.files) {

          console.log('submit', resp);
          if (resp && resp.landSubmitStatus && resp.landSubmitStatus == true) {
            this.hideSubmitButton = true;
            this.showDelete = false;
          } else {
            this.hideSubmitButton = false;
            this.showDelete = true;
          }

          let mappingData = resp.files.reverse();
          this.mappingData = mappingData
          this.noOfDocuments = mappingData.length;

          //Priority
          // one - LR
          // two - Credit report
          // three - SMS
          // four - Satsure

          if (this.noOfDocuments > 0) {
            this.applicant.getOverAllStatus().subscribe(resp => {
              console.log('getOverAllStatus---->', resp)
              let overAllResp = resp;
              if (resp && resp.message == 'success') {
                if (resp && resp.data && resp.data.landDetails && resp.data.landDetails == true) {
                  if (resp && resp.data && resp.data.cicReport && resp.data.cicReport == true) {
                    if (resp && resp.data && resp.data.npaStatus == false) {
                      if (resp && resp.data && resp.data.isSmsSent == false && resp.data.consent_feedback_status.toLowerCase() == "pending") {
                        this.applicant.sendSmsManual(sessionStorage.getItem('wl-applicant-id')).subscribe(resp => {
                          console.log('sms--->', resp);
                          if (resp && resp.success) {

                          }
                        })
                      } else if (resp && resp.data && resp.data.isSmsSent == true && resp.data.consent_feedback_status.toLowerCase() == "yes" && resp.data.satSureData == false) {
                        let data = {
                          appId: sessionStorage.getItem('wl-applicant-id'),
                        }
                        this.applicant.callSatsure(data).subscribe(resp => {
                          console.log('callSatsureApi--->', resp);
                        })
                      } else {
                        // do nothing
                        console.log('is sms already sent or consent form is submited')
                      }
                    } else {

                    }

                  } else {
                    console.log('credit report not present')
                    this.applicant.getCreditData(this.stateCode, this.repeatGetCreditScoreAPICount).subscribe(resp => {
                      console.log('getCreditData--->API', resp);
                      if (resp && resp.success && resp.message && (resp.message == "Report Generated Successfully" ||
                        resp.message == "Credit Report fetched successfully")) {
                        if (resp && resp.npaStatusFlag == false) {
                          if (overAllResp && overAllResp.data && overAllResp.data.isSmsSent == false && overAllResp.data.consent_feedback_status.toLowerCase() == "pending") {
                            this.applicant.sendSmsManual(sessionStorage.getItem('wl-applicant-id')).subscribe(resp => {
                              console.log(resp)
                              if (resp && resp.success) {
                                console.log('sms sent')
                              } else {
                                console.log('sms not sent')
                              }
                            })
                          } else if (overAllResp && overAllResp.data && overAllResp.data.isSmsSent == true && overAllResp.data.consent_feedback_status.toLowerCase() == "yes" && overAllResp.data.satSureData == false) {
                            let data = {
                              appId: sessionStorage.getItem('wl-applicant-id'),
                            }
                            this.applicant.callSatsure(data).subscribe(resp => {
                              console.log('callSatsureApi--->', resp);
                            })
                          } else {
                            // do nothing
                            console.log('is sms already sent or consent form is submited')
                          }
                        } else {
                          // do nothing
                          console.log('npa status is true')
                        }
                      } else {
                        this.repeatGetCreditScoreAPICount =
                          this.repeatGetCreditScoreAPICount + 1;
                        this.applicant.getCreditData(this.stateCode, this.repeatGetCreditScoreAPICount).subscribe(resp => {
                          console.log('getCreditData--->API', resp);
                          if (resp && resp.success && resp.message && (resp.message == "Report Generated Successfully" ||
                            resp.message == "Credit Report fetched successfully")) {

                            if (resp && resp.npaStatusFlag == false) {
                              if (overAllResp && overAllResp.data && overAllResp.data.isSmsSent == false && overAllResp.data.consent_feedback_status.toLowerCase() == "pending") {
                                this.applicant.sendSmsManual(sessionStorage.getItem('wl-applicant-id')).subscribe(resp => {
                                  console.log(resp)
                                  if (resp && resp.success) {
                                    console.log('sms sent')
                                  } else {
                                    console.log('sms not sent')
                                  }
                                })
                              } else if (overAllResp && overAllResp.data && overAllResp.data.isSmsSent == true && overAllResp.data.consent_feedback_status.toLowerCase() == "yes" && overAllResp.data.satSureData == false) {
                                let data = {
                                  appId: sessionStorage.getItem('wl-applicant-id'),
                                }
                                this.applicant.callSatsure(data).subscribe(resp => {
                                  console.log('callSatsureApi--->', resp);
                                })
                              } else {
                                // do nothing
                                console.log('is sms already sent or consent form is submited')
                              }
                            } else {
                              // do nothing
                              console.log('npa status is true')
                            }
                          }
                        })

                      }
                    })
                  }
                } else {
                  console.log('landetails === false')
                  this.disableSubmitLandRecords = false
                }

              } else {
                console.log('getOverAllStatus unsuccess')
              }
            })
          } else {
            console.log('document lenght is zero')
          }

          this.breArray = []
          console.log(mappingData, "MAPPING DATA 298");
          let name_as_per_bhumi = this.profile.name;
          console.log(name_as_per_bhumi, "name from sessionStorage");
          for (let i = 0; i < mappingData.length; i++) {
            const namesArray = [];
            resp.files.forEach(({ DistId, TehId, halkaid, village_eng, khasraNumber }) => {
              console.log(namesArray, "304")
              namesArray.push(DistId, TehId, halkaid, village_eng, khasraNumber);
              this.namesArray = namesArray;
              console.log('namesArray', namesArray)
            });
            // if (mappingData[i].file) {
            // if (mappingData[i].bhoomi_details) {
            if (mappingData[i] && mappingData[i].land_bre_status) {
              console.log(mappingData[i], "312")
              this.breArray.push(mappingData[i].land_bre_status)
              if (mappingData[i].landBreStatus == 'Failure') {
                console.log('enter our condtion');
                this.disableSubmitLandRecords = true
                this.showDelete = true;
              } else if (mappingData.length == 1 && mappingData[0].landBreStatus == 'Success') {
                console.log('only ', this.hideSubmitButton)
                this.disableSubmitLandRecords = false
                if (this.hideSubmitButton) {
                  this.showDelete = false;
                } else {
                  this.showDelete = true;
                }
              }
            }
            (this.ownershipForm.controls.bhoomi_details as UntypedFormArray).push(this.fb.group({
              name_as_per_bhumi: [this.profile.name ? this.profile.name : ""],
              land_area: [mappingData[i] && mappingData[i].land_details && mappingData[i].land_details.landParcelDetails && mappingData[i].land_details.landParcelDetails[0] && mappingData[i].land_details.landParcelDetails[0].surveyNoArea && mappingData[i].land_details.landParcelDetails[0].surveyNoArea[0] ? mappingData[i].land_details.landParcelDetails[0].surveyNoArea[0] : ""],
              land_ownership: [mappingData[i] && mappingData[i].ownershipdetails && mappingData[i].ownershipdetails.ownerDetails && mappingData[i].ownershipdetails.ownerDetails[0] && mappingData[i].ownershipdetails.ownerDetails[0].ownerDetail && mappingData[i].ownershipdetails.ownerDetails[0].ownerDetail[0] && mappingData[i].ownershipdetails.ownerDetails[0].ownerDetail[0].ownerName && mappingData[i].ownershipdetails.ownerDetails[0].ownerDetail[0].ownerName[0] ? mappingData[i].ownershipdetails.ownerDetails[0].ownerDetail[0].ownerName[0] : ""],
              charge_details: [mappingData[i] && mappingData[i].isMortgage == true ? "Yes" : "No"],
            }));

          }

          console.log((this.ownershipForm.controls.bhoomi_details as UntypedFormArray).length)
          if((this.ownershipForm.controls.bhoomi_details as UntypedFormArray).length == 5){
            this.disableBcoz5landsAlready = true;
            this.snackbar.open("Maximum 5 land records only allowed","OK",{duration:5000})
            // return
          }

          // this.breArray = ['Failure', 'Success','Success']
          this.breArrayNew = this.breArray.filter(item => {
            if (item == "Failure") {
              return item
            }
          })

          console.log(this.breArrayNew)
          if (this.breArrayNew.length > 0) {
            this.disableSubmitLandRecords = true
          } else {
            this.disableSubmitLandRecords = false
          }

        }
        // }else{

        // }

      })
    });

    this.applicant.getDistricts().subscribe(resp => {
      if (resp && resp.success) {
        console.log(resp.result)
        let dist = resp.result
        let newDist = dist.map(obj => {
          let objct = {}

          objct['name'] = obj.distname;
          objct['id'] = obj.distid;
          objct['engname'] = obj.distnameeng;
          objct['combinedName'] = obj.distname + ' / ' + obj.distnameeng
          return objct
        })
        this.districts = newDist
        console.log(newDist)
      }
    })

    this.disableSubmitLandRecords = true
  }

  getTehsil(value) {
    console.log(value)
    this.showWaitingLR = true
    sessionStorage.setItem('selectedDist', value.id)
    sessionStorage.setItem('selectedDistName', value.name)
    sessionStorage.setItem('selectedDistNameEng', value.engname)
    this.applicant.getTehsil(value.id).subscribe(resp => {

      console.log(resp)
      if (resp && resp.success) {
        this.tehsilDisabled = false
        this.showWaitingLR = false
        console.log(resp.result)
        let teh = resp.result
        let newTeh = teh.map(obj => {
          let objct = {}

          objct['name'] = obj.tehname;
          objct['id'] = obj.tehid;
          objct['engname'] = obj.tehnameeng;
          objct['combinedName'] = obj.tehname + ' / ' + obj.tehnameeng
          return objct
        })
        this.tehsils = newTeh
        console.log(newTeh)

      }

    })

  }

  getHalka(value: any) {
    console.log(value);
    this.showWaitingLR = true;
    let data = {
      distid: sessionStorage.getItem("selectedDist"),
      tehid: value.id,
    };
    sessionStorage.setItem("selectedTeh", value.id);
    sessionStorage.setItem("selectedTehName", value.name);
    sessionStorage.setItem("selectedTehNameEng", value.engname);

    this.applicant.getHalka(data).subscribe((resp) => {
      console.log('halkaRes--->', resp);
      if (resp && resp.success) {
        this.showWaitingLR = false;
        this.halkaDisabled = false;
        console.log(resp.result);
        let vil = resp.result;
        let newVil = vil.map((obj) => {
          let objct = {};

          objct["name"] = obj.halkaname;
          objct["id"] = obj.halkaid;
          objct["engname"] = obj.halkanameeng;
          objct["combinedName"] = obj.halkaname + " / " + obj.halkanameeng;

          return objct;
        });
        this.halka = newVil;

      } else {

      }
    });
  }

  getVillage(value) {
    console.log(value)
    this.showWaitingLR = true
    let data = {
      distid: sessionStorage.getItem("selectedDist"),
      tehid: sessionStorage.getItem('selectedTeh'),
      halkaid: value.id
    }
    sessionStorage.setItem("selectedHalka", value.id);
    sessionStorage.setItem("selectedHalkaName", value.name);
    sessionStorage.setItem("selectedHalkaNameEng", value.engname);
    this.applicant.getVillage(data).subscribe(resp => {
      console.log(resp)
      if (resp && resp.success) {
        this.showWaitingLR = false
        this.villageDisabled = false
        this.khasraDisabled = false

        console.log(resp.result)
        let vil = resp.result
        let newVil = vil.map(obj => {
          let objct = {}

          objct['name'] = obj.villname;
          objct['id'] = obj.villid;
          objct['engname'] = obj.villnameeng;
          objct['combinedName'] = obj.villname + ' / ' + obj.villnameeng
          objct['lgd_Code'] = obj.lgd_Code;
          objct['village_region_id'] = obj.village_region_id
          return objct
        })
        this.villages = newVil
        console.log(newVil)

      }

    })

  }

  onSelectVillage(value) {
    console.log(value)
    sessionStorage.setItem('selectedLgdCode', value.lgd_Code)
    sessionStorage.setItem('selectedVillageCode', value.village_region_id)
    sessionStorage.setItem('selectedVillageName', value.name)
    sessionStorage.setItem('selectedVillageNameEng', value.engname)
  }

  splitArray(array, chunkSize) {
    array = array && array.length ? array : [];
    const result = [];
    console.log(array)
    for (let i = 0; i < array.length; i += chunkSize) {
      console.log(array.slice(i, i + chunkSize))
      result.push(array.slice(i, i + chunkSize));
    }
    console.log(result);
    return result;
  }

  checkArrayMatch(arr1: any[], arr2: any[]): boolean {
    if (arr1.length !== arr2.length) {
      return false;
    }

    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) {
        return false;
      }
    }

    return true;
  }


  fetchLandRecords(data) {
    console.log(this.bhoomi_details.length, (this.ownershipForm.controls.bhoomi_details as UntypedFormArray).length);
    if((this.ownershipForm.controls.bhoomi_details as UntypedFormArray).length == 5){
      this.disableBcoz5landsAlready = true;
      this.snackbar.open("Maximum 5 land records only allowed","OK",{duration:5000})
      return
    }
    let a = sessionStorage.getItem('selectedDist')
    let b = sessionStorage.getItem("selectedTeh");
    let c = sessionStorage.getItem("selectedHalka");
    let d = sessionStorage.getItem('selectedVillageNameEng')
    let e = this.landForm.getRawValue().khasra
    // debugger
    let my_array = []
    my_array.push(a, b, c, d, e);
    console.log('fetchdata', my_array);
    console.log('this.namesArray', this.namesArray)
    const chunkSize = 5;
    const splitArrays = this.splitArray(this.namesArray, chunkSize);
    console.log('splitArrays', splitArrays);

    this.matchedArrays = [];

    for (var targetArray of splitArrays) {
      console.log(targetArray)
      this.isMatch = this.checkArrayMatch(my_array, targetArray);
      if (this.isMatch) {
        console.log('isMatch', this.isMatch);
        this.matchedArrays.push(targetArray);
        console.log('matchedArrays', this.matchedArrays);
        console.log('targetArray', targetArray);

      } else {
        console.log('not match')
      }
    }
    console.log('length', this.matchedArrays, this.matchedArrays.length);
    if (this.matchedArrays.length > 0) {
      this.snackbar.open('Entered Duplicate land record, Please enter different one', "OK", { duration: 8000 })
    } else {
      this.showWaitingLR = true
      let showTimeOutMessage = true

      this.subText = "आपकी भूमि का विवरण प्राप्त किया जा रहा है। ";
      this.showSpinnerWithMessage = true;


      console.log(data)
      let lgdCode = sessionStorage.getItem('selectedLgdCode')
      this.applicant.getKhasraDetails(lgdCode).subscribe(resp => {
        console.log(resp)
        if (resp && resp.list && resp.list.KhasraDetails) {
          let khasraDetails = resp.list.KhasraDetails;
          let filterdata = khasraDetails.filter(value => value.KhasraType[0] == 'S')
          console.log(filterdata, 'khasraDetails');
          let filterdatafinal = filterdata.filter(value => value.khasraNo[0] == data.khasra)
          console.log("filterdata final", filterdatafinal)
          if (filterdatafinal.length > 0) {
            let newdata = {
              khasraId: filterdatafinal[0].khasraId[0],
              village_region_id: sessionStorage.getItem('selectedVillageCode'),
              TehId: sessionStorage.getItem('selectedTeh'),
              DistId: sessionStorage.getItem('selectedDist'),
              appId: sessionStorage.getItem('wl-applicant-id'),
              khasraNumber: this.landForm.getRawValue().khasra,
              name2: this.profile && this.profile.name ? this.profile.name : "",
              district: sessionStorage.getItem('selectedDistName'),
              taluk: sessionStorage.getItem('selectedTehName'),
              village: sessionStorage.getItem('selectedVillageName'),
              district_eng: sessionStorage.getItem('selectedDistNameEng'),
              taluk_eng: sessionStorage.getItem('selectedTehNameEng'),
              village_eng: sessionStorage.getItem('selectedVillageNameEng')
            }
            let landData = {
              khasraId: filterdatafinal[0].khasraId[0],
              TehId: sessionStorage.getItem('selectedTeh'),
              DistId: sessionStorage.getItem('selectedDist'),

            }


            this.applicant.getKhasraLandDetails(landData).subscribe(resp => {
              console.log(resp)

              if (resp && resp.message == "success" && resp.land_details) {

                if (resp && resp.land_details) {
                  sessionStorage.setItem('landDetails', JSON.stringify(resp.land_details))
                  console.log(resp.land_details, " - Land Details");
                }


                this.applicant.getKhasraOwnerDetails(landData).subscribe(resp => {
                  console.log(resp)

                  if (resp && resp.message == "success" && resp.ownershipdetails) {

                    if (resp && resp.ownershipdetails) {
                      sessionStorage.setItem('ownershipDetails', JSON.stringify(resp.ownershipdetails))
                      console.log(resp.ownershipdetails, " - OwnerShip Details");
                    }

                    let bredataETB = {
                      khasraId: filterdatafinal[0].khasraId[0],
                      village_region_id: sessionStorage.getItem('selectedVillageCode'),
                      TehId: sessionStorage.getItem('selectedTeh'),
                      DistId: sessionStorage.getItem('selectedDist'),
                      appId: sessionStorage.getItem('wl-applicant-id'),
                      khasraNumber: this.landForm.getRawValue().khasra,
                      name2: this.profile && this.profile.name ? this.profile.name : "",
                      district: sessionStorage.getItem('selectedDistName'),
                      taluk: sessionStorage.getItem('selectedTehName'),
                      village: sessionStorage.getItem('selectedVillageName'),
                      land_details: JSON.parse(sessionStorage.getItem('landDetails')),
                      ownershipdetails: JSON.parse(sessionStorage.getItem('ownershipDetails')),
                      district_eng: sessionStorage.getItem('selectedDistNameEng'),
                      taluk_eng: sessionStorage.getItem('selectedTehNameEng'),
                      village_eng: sessionStorage.getItem('selectedVillageNameEng'),
                      halkaid: sessionStorage.getItem("selectedHalka"),
                      halkaname: sessionStorage.getItem("selectedHalkaName"),
                      halkanameeng: sessionStorage.getItem("selectedHalkaNameEng"),
                    }

                    let breDataNTB = {
                      khasraId: filterdatafinal[0].khasraId[0],
                      village_region_id: sessionStorage.getItem('selectedVillageCode'),
                      TehId: sessionStorage.getItem('selectedTeh'),
                      DistId: sessionStorage.getItem('selectedDist'),
                      appId: sessionStorage.getItem('wl-applicant-id'),
                      khasraNumber: this.landForm.getRawValue().khasra,
                      name2: this.profile && this.profile.name ? this.profile.name : "",
                      district: sessionStorage.getItem('selectedDistName'),
                      taluk: sessionStorage.getItem('selectedTehName'),
                      village: sessionStorage.getItem('selectedVillageName'),
                      land_details: JSON.parse(sessionStorage.getItem('landDetails')),
                      ownershipdetails: JSON.parse(sessionStorage.getItem('ownershipDetails')),
                      district_eng: sessionStorage.getItem('selectedDistNameEng'),
                      taluk_eng: sessionStorage.getItem('selectedTehNameEng'),
                      village_eng: sessionStorage.getItem('selectedVillageNameEng'),
                      halkaid: sessionStorage.getItem("selectedHalka"),
                      halkaname: sessionStorage.getItem("selectedHalkaName"),
                      halkanameeng: sessionStorage.getItem("selectedHalkaNameEng"),
                      jrnytype: "NTB"
                    }
                    let bredata = this.isNTB ? breDataNTB : bredataETB

                    this.subText = "आपकी भूमि के विवरण सत्यापित हो रहे हैं।"
                    this.applicant.getBREStatus(bredata).subscribe(resp => {
                      console.log(resp)
                      showTimeOutMessage = false
                      // this.showSpinner = false
                      this.showWaitingLR = false
                      this.showSpinnerWithMessage = false
                      if (resp && resp.message == "success" && resp.result.land_bre_status == "Success") {

                        this.creditreport.getBreStatus().subscribe(result => {
                          console.log(result);
                          // result = "Failure"
                          if (result == "Failure") {
                            this.router.navigateByUrl('/laas/bre-status', { skipLocationChange: true }).then(() => {
                              this.router.navigate(['/laas/land-records-mp']);
                            })
                            this.snackbar.open(resp.bre_failure_reason?resp.bre_failure_reason:"Failed in BRE","OK",{duration:5000})
                          } else {
                            let distid = { distId: sessionStorage.getItem('selectedDist') }

                            let data = {
                              village_region_id: sessionStorage.getItem('selectedVillageCode'),
                              khasraNumber: this.landForm.getRawValue().khasra,
                              appId: sessionStorage.getItem('wl-applicant-id'),
                              district: sessionStorage.getItem('selectedDistName'),
                              taluk: sessionStorage.getItem('selectedTehName'),
                              village: sessionStorage.getItem('selectedVillageName'),
                              district_eng: sessionStorage.getItem('selectedDistNameEng'),
                              taluk_eng: sessionStorage.getItem('selectedTehNameEng'),
                              village_eng: sessionStorage.getItem('selectedVillageNameEng')
                            }
                            this.applicant.callSatsure(data).subscribe(resp => {
                              console.log(resp)
                              this.router.navigateByUrl('/laas/bre-status', { skipLocationChange: true }).then(() => {
                                this.router.navigate(['/laas/land-records-mp']);
                              })
                              if (resp && resp.message && resp.message == "Report generation requested") {
                                console.log("Satsure data requested", resp)
                                this.snackbar.open(resp.message, "OK", { duration: 3000 })

                              } else {

                              }

                            }, err => {
                              console.log(err)
                              this.router.navigateByUrl('/laas/bre-status', { skipLocationChange: true }).then(() => {
                                this.router.navigate(['/laas/land-records-mp']);
                              })
                            })
                          }
                        })
                        
                      } else {

                        const dialogRef = this.dialog.open(OpenDialogYesOrNo, {
                          width: 'auto', height: 'auto',
                          data: { content1: "हमें खेद है कि राज्य भू अभिलेख रिकॉर्ड्स  मे आपकी भूमि संबन्धित उपलब्ध जानकारी  बैंक मानकों के अनुरूप नहीं हैं। We are sorry to inform you that the information available regarding your land in the State Land Records Records is not as per the bank standards.", button1Text: "OK", }
                        });
                        dialogRef.afterClosed().subscribe((res) => {

                          this.router.navigateByUrl('/laas/bre-status', { skipLocationChange: true }).then(() => {
                            this.router.navigate(['/laas/land-records-mp']);
                          })


                          if (resp && resp.message == "success" && resp.result.land_bre_status == "Failure") {
                            let result = resp.result;
                            let data = {};
                            let breFailure = { profile_match: 0, isIrrigated: false, isCourtCase: false, isMortgage: false, land_bre_status: 'Failure' }
                            if (result && !result.profile_match) {
                              data = { one: "हमें खेद है कि राज्य भू अभिलेख रिकॉर्ड्स  मे आपकी भूमि संबन्धित उपलब्ध जानकारी  बैंक मानकों के अनुरूप नहीं हैं।", two: "We are sorry to inform you that the information available regarding your land in the State Land Records Records is not as per the bank standards." }
                            } else if (result && !result.isIrrigated) {
                              data = { one: "हमें खेद है कि राज्य भू अभिलेख रिकॉर्ड्स  मे आपकी भूमि संबन्धित उपलब्ध जानकारी  बैंक मानकों के अनुरूप नहीं हैं।", two: "We are sorry to inform you that the information available regarding your land in the State Land Records Records is not as per the bank standards." }
                            } else if (result && result.isCourtCase) {
                              data = { one: "हमें खेद है कि राज्य भू अभिलेख रिकॉर्ड्स  मे आपकी भूमि संबन्धित उपलब्ध जानकारी  बैंक मानकों के अनुरूप नहीं हैं।", two: "We are sorry to inform you that the information available regarding your land in the State Land Records Records is not as per the bank standards." }
                            } else if (result && result.isMortgage) {
                              data = { one: "हमें खेद है कि राज्य भू अभिलेख रिकॉर्ड्स  मे आपकी भूमि संबन्धित उपलब्ध जानकारी  बैंक मानकों के अनुरूप नहीं हैं।", two: "We are sorry to inform you that the information available regarding your land in the State Land Records Records is not as per the bank standards." }
                            } else if (result && result.ownershare) {
                              data = { one: "हमें खेद है कि राज्य भू अभिलेख रिकॉर्ड्स  मे आपकी भूमि संबन्धित उपलब्ध जानकारी  बैंक मानकों के अनुरूप नहीं हैं।", two: "We are sorry to inform you that the information available regarding your land in the State Land Records Records is not as per the bank standards." }
                            }

                          }
                        })

                      }

                    }, err => {
                      console.log(err);//get the error in error handler
                      showTimeOutMessage = false
                      // this.showSpinner = false
                      this.snackbar.open(JSON.stringify(err.message), 'Get BRE details API Failed.  OK', { duration: 3000 })
                      this.showSpinnerWithMessage = false
                      this.snackbar.open(JSON.stringify(err.message), 'API Failed.  OK', { duration: 3000 })
                      const dialogRef = this.dialog.open(OpenDialogYesOrNo, {
                        width: 'auto', height: 'auto',
                        data: { content1: "भूमि विवरण एपीआई में डाउनटाइम चल रहा है। कृपया कुछ देर बाद प्रयास करें।", content2: "Downtime in Land Record API, Please try after sometime.", button1Text: "OK", }
                      });

                    })


                  } else {
                    if (resp && resp.message == "success" && !resp.ownershipdetails) {
                      let data = { one: "हमें खेद है कि राज्य भू अभिलेख रिकॉर्ड्स  मे आपकी भूमि संबन्धित उपलब्ध जानकारी  बैंक मानकों के अनुरूप नहीं हैं।", two: "We are sorry to inform you that the information available regarding your land in the State Land Records Records is not as per the bank standards." };
                      const dialogRef = this.dialog.open(OpenDialogYesOrNo, {
                        width: 'auto', height: 'auto',
                        data: { content1: data['one'], content2: data['two'], button1Text: "OK", }
                      });


                    } else if (resp && resp.message) {
                      this.snackbar.open(resp.message, "OK", { duration: 3000 })
                    }
                  }

                }, err => {
                  console.log(err);//get the error in error handler
                  showTimeOutMessage = false
                  this.snackbar.open(JSON.stringify(err.message), 'Get Khasra owner details API Failed.  OK', { duration: 3000 })
                  // this.showSpinner = false
                  this.showSpinnerWithMessage = false
                  const dialogRef = this.dialog.open(OpenDialogYesOrNo, {
                    width: 'auto', height: 'auto',
                    data: { content1: "सिस्टम आपके भूमि विवरण को सत्यापित करने में विफल रहा है। कृपया कुछ देर बाद प्रयास करें।", content2: "The system has failed to verify your land details. Please try after some time.", button1Text: "OK" }
                  });

                })
              } else {
                if (resp && resp.message == "success" && !resp.land_details) {
                  let data = { one: "हमें खेद है कि राज्य भू अभिलेख रिकॉर्ड्स  मे आपकी भूमि संबन्धित उपलब्ध जानकारी  बैंक मानकों के अनुरूप नहीं हैं।", two: "We are sorry to inform you that the information available regarding your land in the State Land Records Records is not as per the bank standards." };
                  const dialogRef = this.dialog.open(OpenDialogYesOrNo, {
                    width: 'auto', height: 'auto',
                    data: { content1: data['one'], content2: data['two'], button1Text: "OK", }
                  });



                }
              }

            }, err => {
              console.log(err);
              this.snackbar.open(JSON.stringify(err.message), 'Get Khasra Land details API Failed.  OK', { duration: 3000 })
              showTimeOutMessage = false
              // this.showSpinner = false
              this.showSpinnerWithMessage = false
              const dialogRef = this.dialog.open(OpenDialogYesOrNo, {
                width: 'auto', height: 'auto',
                data: { content1: "भूमि विवरण एपीआई में डाउनटाइम चल रहा है। कृपया कुछ देर बाद प्रयास करें।", content2: "Downtime in Land Record API, Please try after sometime.", button1Text: "OK", }
              });

            })
          } else {
            this.snackbar.open("No matching Khasra found", "OK", { duration: 3000 })
          }
        } else {
          showTimeOutMessage = false
          // this.showSpinner = false
          this.showSpinnerWithMessage = false
          const dialogRef = this.dialog.open(OpenDialogYesOrNo, {
            width: 'auto', height: 'auto',
            data: { content1: "सिस्टम आपका खसरा नंबर खोजने में विफल रहा है, कृपया सही खसरा नंबर दर्ज करें।", content2: "The system has failed to find your khasra number. Kindly enter the correct khasra number.", button1Text: "OK", }
          });
        }
      }, err => {
        console.log(err);//get the error in error handler
        this.showWaitingLR = false
        this.snackbar.open(JSON.stringify(err.message), 'Get Khasra details API Failed.  OK', { duration: 3000 })
        showTimeOutMessage = false
        // this.showSpinner = false
        this.showSpinnerWithMessage = false
        const dialogRef = this.dialog.open(OpenDialogYesOrNo, {
          width: 'auto', height: 'auto',
          data: { content1: "भूमि विवरण एपीआई में डाउनटाइम चल रहा है। कृपया कुछ देर बाद प्रयास करें।", content2: "Downtime in Land Record API, Please try after sometime.", button1Text: "OK", }
        });
        dialogRef.afterClosed().subscribe(res => {
          console.log(res)

          if (res == "close") {
            // window.close()
          } else {
            window.location.reload()
          }
        })
      })
    }
  }

  
  deleteRecord(i) {
    console.log(i);
    this.applicant.deleteBhoomiRecord(i).subscribe(resp => {
      console.log(resp);
      this.bhoomi_details().removeAt(i);
      this.router.navigateByUrl('/laas/bre-status', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/laas/land-records-mp']);
      })
    })
  }

  submitLandRecords() {
    const dialogRef = this.dialog.open(OpenDialogYesOrNo, {
      width: 'auto', height: 'auto',
      data: {
        content: constants.DYUWANNA_ADD_MORE_LANDS,
        button1Text: "Yes", button2Text: "No"
      }
    });
    dialogRef.afterClosed().subscribe(res => {
      // this.router
      // .navigateByUrl("/laas/bre-status", {
      //   skipLocationChange: true,
      // })
      // .then(() => {
      //   this.router.navigate(["/laas/land-records-mp"]);
      // }).then(() => {
        console.log(res)
        if (res == "close") {
          let id = sessionStorage.getItem('wl-applicant-id');
          let status = 'No'
          let value = { status, id }
          this.applicant.clickSubmit(value).subscribe(res => {
            console.log('final result', res)
            if (res.success == true) {
              this.hideSubmitButton = true;
              this.creditCheckRequired = res.creditCheckRequired;
            } else {
              this.hideSubmitButton = false;
            }
  
            this.showDelete = false;
            this.disableSubmitLandRecords = true
            this.applicant.getLandDetails().subscribe(resp => {
              console.log(resp)
              if (resp && resp.files) {
                let mappingData = resp.files;
                let breArray = [];
                for (let i = 0; i < mappingData.length; i++) {
                  if (mappingData[i] && mappingData[i].land_bre_status == ("success" || "Success")) {
  
                  } else if (mappingData[i] && mappingData[i].land_bre_status == ("failure" || "Failure")) {
                    console.log(mappingData[i])
                    this.isLandBreFailure = true
                  }
                }
                // this.isLandBreFailure = false
                if (!this.isLandBreFailure && this.creditCheckRequired) {
                  this.applicant.getCreditData(this.stateCode, this.repeatGetCreditScoreAPICount).subscribe(resp => {
                    console.log(resp)
                    if (resp &&
                      resp.success == true && resp.message &&
                      (resp.message == "Report Generated Successfully" ||
                        resp.message == "Credit Report fetched successfully")) {
                      if (resp && resp.result && resp.result.npaStatus == false) {
                        this.creditreport.getBreStatus().subscribe(result => {
                          console.log(result);
                          // result = "Failure"
                          if (result == "Failure" || result == "failure") {
                            this.snackbar.open(resp.bre_failure_reason?resp.bre_failure_reason:"Failed in BRE","OK",{duration:5000})
                          } else if (result == "Success" || result == "success") {
                            this.applicant.getOverAllStatus().subscribe(resp => {
                              console.log(resp)
                              if (resp && resp.message == "success") {
                                if (resp && resp.data && resp.data.satSureData == true && resp.data.isSmsSent == true) {
                                  this.disableSubmitLandRecords = true
                                } else if (resp && resp.data && resp.data.isSmsSent == false) {
                                  let data = {
                                    appId: sessionStorage.getItem('wl-applicant-id'),
                                  }
                                  // this.applicant.callSatsure(data).subscribe(resp => {
                                  //   console.log(resp)
                                  //   if (resp && resp.success) {
                                  this.applicant.sendSmsManual(sessionStorage.getItem('wl-applicant-id')).subscribe(resp => {
                                    console.log(resp)
                                    if (resp && resp.success) {
                                      this.disableSubmitLandRecords = true
                                    }
                                  })
                                  //   }
                                  // })
                                } else if (resp && resp.data && resp.data.satSureData == true && resp.data.isSmsSent == false) {
                                  // this.disableSubmitLandRecords = false
                                  this.applicant.sendSmsManual(sessionStorage.getItem('wl-applicant-id')).subscribe(resp => {
                                    console.log(resp)
                                    if (resp && resp.success) {
                                      this.disableSubmitLandRecords = true
                                    }
                                  })
                                } else if (resp && resp.data && resp.data.satSureData == false && resp.data.isSmsSent == true && resp.data.consent_feedback_status == "yes") {
                                  let data = {
                                    appId: sessionStorage.getItem('wl-applicant-id'),
                                  }
                                  this.applicant.callSatsure(data).subscribe(resp => {
                                    console.log(resp)
                                    if (resp && resp.success) {
                                      this.disableSubmitLandRecords = true
                                    }
                                  })
                                } else {
                                  this.disableSubmitLandRecords = true
                                }
                              }
                            })
                          }
                        })
                      }
                    } else {
                      this.repeatGetCreditScoreAPICount =
                        this.repeatGetCreditScoreAPICount + 1;
                      this.applicant.getCreditData(this.stateCode, this.repeatGetCreditScoreAPICount).subscribe(resp => {
                        console.log(resp)
                        if (resp &&
                          resp.success == true && resp.message &&
                          (resp.message == "Report Generated Successfully" ||
                            resp.message == "Credit Report fetched successfully")) {
                          if (resp && resp.result && resp.result.npaStatus == false) {
                            this.creditreport.getBreStatus().subscribe(result => {
                              console.log(result);
                              // result = "Failure"
                              if (result == "Failure" || result == "failure") {
                                this.snackbar.open(resp.bre_failure_reason?resp.bre_failure_reason:"Failed in BRE","OK",{duration:5000})
                              } else if (result == "Success" || result == "success") {
                                this.applicant.getOverAllStatus().subscribe(resp => {
                                  console.log(resp)
                                  if (resp && resp.message == "success") {
                                    if (resp && resp.data && resp.data.satSureData == true && resp.data.isSmsSent == true) {
                                      this.disableSubmitLandRecords = true
                                    } else if (resp && resp.data && resp.data.isSmsSent == false) {
                                      let data = {
                                        appId: sessionStorage.getItem('wl-applicant-id'),
                                      }
                                      // this.applicant.callSatsure(data).subscribe(resp => {
                                      //   console.log(resp)
                                      //   if (resp && resp.success) {
                                      this.applicant.sendSmsManual(sessionStorage.getItem('wl-applicant-id')).subscribe(resp => {
                                        console.log(resp)
                                        if (resp && resp.success) {
                                          this.disableSubmitLandRecords = true
                                        }
                                      })
                                      //   }
                                      // })
                                    } else if (resp && resp.data && resp.data.satSureData == true && resp.data.isSmsSent == false) {
                                      // this.disableSubmitLandRecords = false
                                      this.applicant.sendSmsManual(sessionStorage.getItem('wl-applicant-id')).subscribe(resp => {
                                        console.log(resp)
                                        if (resp && resp.success) {
                                          this.disableSubmitLandRecords = true
                                        }
                                      })
                                    } else if (resp && resp.data && resp.data.satSureData == false && resp.data.isSmsSent == true && resp.data.consent_feedback_status == "yes") {
                                      let data = {
                                        appId: sessionStorage.getItem('wl-applicant-id'),
                                      }
                                      this.applicant.callSatsure(data).subscribe(resp => {
                                        console.log(resp)
                                        if (resp && resp.success) {
                                          this.disableSubmitLandRecords = true
                                        }
                                      })
                                    } else {
                                      this.disableSubmitLandRecords = true
                                    }
                                  }
                                })
                              }
                            })
                          }
                        }
                      })
                    }
                  })
                } else {
                  this.disableSubmitLandRecords = true; //if land bre is failure for any land disable submit
                  this.snackbar.open("Land BRE failure found","OK",{duration:3000})
                }
  
              } else {
                this.snackbar.open("Failed to fetch Land records BRE status information.", "OK", { duration: 3000 })
              }
            },()=>{
              this.snackbar.open("Failed to fetch Land records BRE status information.","OK",{duration:3000})
            })
          },()=>{
            this.snackbar.open("Failed to submit","OK",{duration:3000})
          })
  
  
        } else {
          this.disableSubmitLandRecords = false
        }
      // })

    })

  }

}
